<template>
  <div class="form-container">
    <div class="load" v-if="isLoading">
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
    </div>
    <div v-else-if="specialMemberState !== 0">
      <h2 v-if="specialMemberState === null">申請成為特約廠商</h2>
      <h2 v-else>特約廠商資料</h2>
      <form>
        <div>
          <div class="form-title">公司/機構名稱</div>
          <input
            type="text"
            :value="specialMemberData.company_company_name"
            @input="
              $store.dispatch('updataSingleSpecialMemberData', {
                updateKey: 'company_company_name',
                updateValue: $event.target.value,
              })
            "
            @change="dataBeChange = true"
          />
          <div
            class="error-message"
            v-if="!dataVerificationResult.company_company_name"
          >
            請填寫您的公司/機構名稱
          </div>
        </div>
        <div>
          <div class="form-title">公司/聯絡地址</div>
          <div class="address-container">
            <div class="flex-container">
              <input
                class="flex-item"
                type="text"
                placeholder="台灣"
                :value="specialMemberData.company_address_country"
                @input="
                  $store.dispatch('updataSingleSpecialMemberData', {
                    updateKey: 'company_address_country',
                    updateValue: $event.target.value,
                  })
                "
                @change="dataBeChange = true"
              />
              <div
                class="dropdown-title flex-item"
                v-on:click.prevent="showDropDown_city = !showDropDown_city"
              >
                <a href="#">
                  <div
                    :class="{
                      'title-color':
                        specialMemberData.company_address_county === '縣市',
                    }"
                  >
                    {{ specialMemberData.company_address_county }}
                  </div>
                  <i
                    :class="{
                      'fa-caret-up': showDropDown_city,
                      'fa-caret-down': !showDropDown_city,
                    }"
                    class="fa"
                    aria-hidden="true"
                  ></i>
                </a>
                <transition name="slide-fade">
                  <div class="choice" v-if="showDropDown_city">
                    <ul>
                      <li v-for="(city, index) in displayCityList" :key="index">
                        <span class="item" @click="updatebeChooseCity(city)">{{
                          city
                        }}</span>
                      </li>
                    </ul>
                  </div>
                </transition>
              </div>
              <div
                class="dropdown-title flex-item"
                @click.prevent="showDropDown_zipcode = !showDropDown_zipcode"
              >
                <a href="#">
                  <div
                    :class="{
                      'title-color': displayZipCodeInfo === '郵遞區號',
                    }"
                  >
                    {{ displayZipCodeInfo }}
                  </div>
                  <i
                    :class="{
                      'fa-caret-up': showDropDown_zipcode,
                      'fa-caret-down': !showDropDown_zipcode,
                    }"
                    class="fa"
                    aria-hidden="true"
                  ></i>
                </a>
                <transition name="slide-fade">
                  <div class="choice" v-if="showDropDown_zipcode">
                    <ul>
                      <li
                        v-for="(zipcode, index) in displayZipCodeList"
                        :key="index"
                      >
                        <span
                          class="item"
                          @click="updateZipcode(zipcode.zopcode)"
                          >{{ zipcode.region + zipcode.zopcode }}</span
                        >
                      </li>
                    </ul>
                  </div>
                </transition>
              </div>
            </div>
            <input
              type="text"
              placeholder="地址"
              :value="specialMemberData.company_address"
              @input="
                $store.dispatch('updataSingleSpecialMemberData', {
                  updateKey: 'company_address',
                  updateValue: $event.target.value,
                })
              "
              @change="dataBeChange = true"
            />
            <div
              class="error-message"
              v-if="!dataVerificationResult.company_address"
            >
              請完整填寫您的公司聯絡地址相關資訊
            </div>
          </div>
        </div>
        <div>
          <div class="form-title">負責人名稱</div>
          <input
            type="text"
            :value="specialMemberData.principal_name"
            @input="
              $store.dispatch('updataSingleSpecialMemberData', {
                updateKey: 'principal_name',
                updateValue: $event.target.value,
              })
            "
            @change="dataBeChange = true"
          />
          <div
            class="error-message"
            v-if="!dataVerificationResult.principal_name"
          >
            請填寫您的負責人名稱
          </div>
        </div>
        <div>
          <div class="form-title">負責人聯絡電話</div>
          <input
            type="text"
            :value="specialMemberData.principal_phone"
            @input="
              $store.dispatch('updataSingleSpecialMemberData', {
                updateKey: 'principal_phone',
                updateValue: $event.target.value,
              })
            "
            @change="dataBeChange = true"
          />
          <div
            class="error-message"
            v-if="!dataVerificationResult.principal_phone"
          >
            請填寫您的負責人聯絡電話
          </div>
        </div>
        <div>
          <div class="form-title">電子信箱</div>
          <input
            class="emailExamine"
            type="email"
            :value="specialMemberData.principal_email"
            @input="
              $store.dispatch('updataSingleSpecialMemberData', {
                updateKey: 'principal_email',
                updateValue: $event.target.value,
              })
            "
            @change="dataBeChange = true"
          />
          <div
            class="error-message"
            v-if="!dataVerificationResult.principal_email"
          >
            請填寫您的電子信箱或重新確認信箱格式
          </div>
        </div>
        <div>
          <div class="form-title">LINE ID (非必填)</div>
          <input
            type="text"
            :value="specialMemberData.principal_line_id"
            @input="
              $store.dispatch('updataSingleSpecialMemberData', {
                updateKey: 'principal_line_id',
                updateValue: $event.target.value,
              })
            "
            @change="dataBeChange = true"
          />
        </div>
        <div v-if="specialMemberState === null">
          <div class="form-title">特約商申請時的聲明內容：</div>
          <ul class="statement">
            <li>1. 按稅法規定，黃金交易屬於0稅率，因此交易不附發票。</li>
            <li>2. 特約商對於消費者交易之發票須自負。</li>
            <li>
              3.
              特殊交易項目：來料加工，須簽署「委託加工翻造證明書」文件，釐清黃金原料之合法性，與法律責任。
            </li>
          </ul>
          <div class="agree">
            <input type="checkbox" v-model="isAgree" />
            <label>我已閱讀並同意以上內容</label>
            <div class="error-message" v-if="!isMemberAgreeVerificationResult">
              需同意聲明內容，才可以成為特約會員唷
            </div>
          </div>
        </div>
      </form>
      <button v-if="specialMemberState === null" @click="submitApply">
        送出申請
      </button>
      <button v-else @click="saveSpecialMemberData">儲存變更</button>
      <div class="mobile_backNav" v-if="webElememtHide">
        <i class="fa fa-angle-left"></i>
        <router-link to="/gold/member_mobile">返回會員帳號</router-link>
      </div>
    </div>
    <div v-else class="wait-contract">
      <h2>待審核</h2>
      <p>
        已經收到您的特約廠商申請，我們會盡快審核資料並與您聯絡，收到確認後即可成為特約廠商。
      </p>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import taiwanZipcodeData from "@/constData/taiwanZipCode.js";

export default {
  name: "contractedStoreForm",
  data() {
    return {
      changeInfoData: "",
      //address default data
      showDropDown_city: false,
      taiwanZipcodeData: taiwanZipcodeData.taiwanZipcodeData,
      showDropDown_zipcode: false,
      beChooseCity: "縣市",
      isAgree: "",
      dataBeChange: false,
      isLoading: true,
      dataVerificationResult: {
        company_company_name: true,
        company_address: true,
        principal_name: true,
        principal_phone: true,
        principal_email: true,
      },
      isMemberAgreeVerificationResult: true,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.getters.getToken) {
        vm.$router.push({ name: "member_login" });
      }
    });
  },
  created() {
    if (this.specialMemberState === 1) {
      this.tokenGetSpecialMemberData();
    } else {
      this.isLoading = false;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.dataBeChange) {
      let userResponse = confirm("您尚未儲存資料，確定離開嗎？");
      if (!userResponse) {
        return;
      } else {
        next();
      }
    } else {
      next();
    }
  },
  methods: {
    updatebeChooseCity(city) {
      this.beChooseCity = city;
      this.$store.dispatch("updataSingleSpecialMemberData", {
        updateKey: "company_address_postal_code",
        updateValue: "",
      });
      this.$store.dispatch("updataSingleSpecialMemberData", {
        updateKey: "company_address_county",
        updateValue: city,
      });
    },
    updateZipcode(zipcode) {
      this.$store.dispatch("updataSingleSpecialMemberData", {
        updateKey: "company_address_postal_code",
        updateValue: zipcode,
      });
    },
    async submitApply() {
      let dataVerificationResult = this.dataVerification();
      if (!this.isAgree) {
        this.isMemberAgreeVerificationResult = false;
        return;
      } else {
        this.isMemberAgreeVerificationResult = true;
      }
      if (dataVerificationResult) {
        try {
          await this.$store.dispatch(
            "specialMemberApply",
            this.specialMemberData
          );
          alert(
            "已經收到您的特約廠商申請，我們會盡快審核資料並與您聯絡，收到確認後即可成為特約廠商。"
          );
          this.$store.dispatch("tokenGetMemberInfo");
          this.dataBeChange = false;
        } catch (e) {
          alert(`錯誤訊息:${e},請稍後再試`);
        }
      } else {
        return;
      }
    },
    async tokenGetSpecialMemberData() {
      this.isLoading = true;
      await this.$store.dispatch("tokenGetSpecialMemberData");
      this.isLoading = false;
    },
    async saveSpecialMemberData() {
      let dataVerificationResult = this.dataVerification();
      if (dataVerificationResult) {
        this.isLoading = true;
        try {
          let response = await this.$store.dispatch(
            "saveSpecialMemberData",
            this.specialMemberData
          );
          this.tokenGetSpecialMemberData();
          this.dataBeChange = false;
          alert("更新成功");
          this.isLoading = false;
        } catch (e) {
          alert(`錯誤訊息:${e},請稍後再試`);
        }
      } else {
        return;
      }
    },
    dataVerification() {
      //去空白
      this.stringToTrim();
      //檢驗必填
      let mustValueVerificationResult = this.mustValueVerification();
      if (!mustValueVerificationResult) {
        return false;
      }
      // 檢驗特殊格式:信箱
      let emailExamine = /^.*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
      if (!emailExamine.test(this.specialMemberData.principal_email)) {
        this.dataVerificationResult.principal_email = false;
        return false;
      } else {
        this.dataVerificationResult.principal_email = true;
      }
      return true;
    },
    stringToTrim() {
      this.$store.dispatch("updataSingleSpecialMemberData", {
        updateKey: "company_company_name",
        updateValue: this.specialMemberData.company_company_name.trim(),
      });
      this.$store.dispatch("updataSingleSpecialMemberData", {
        updateKey: "company_address_country",
        updateValue: this.specialMemberData.company_address_country.trim(),
      });
      this.$store.dispatch("updataSingleSpecialMemberData", {
        updateKey: "company_address",
        updateValue: this.specialMemberData.company_address.trim(),
      });
      this.$store.dispatch("updataSingleSpecialMemberData", {
        updateKey: "principal_name",
        updateValue: this.specialMemberData.principal_name.trim(),
      });
      this.$store.dispatch("updataSingleSpecialMemberData", {
        updateKey: "principal_phone",
        updateValue: this.specialMemberData.principal_phone.trim(),
      });
      this.$store.dispatch("updataSingleSpecialMemberData", {
        updateKey: "principal_email",
        updateValue: this.specialMemberData.principal_email.trim(),
      });
      if (this.specialMemberData.principal_line_id !== null) {
        this.$store.dispatch("updataSingleSpecialMemberData", {
          updateKey: "principal_line_id",
          updateValue: this.specialMemberData.principal_line_id.trim(),
        });
      }
    },
    mustValueVerification() {
      let result = true;
      for (var key in this.dataVerificationResult) {
        if (this.specialMemberData[`${key}`] === "") {
          this.dataVerificationResult[`${key}`] = false;
          result = false;
        } else {
          this.dataVerificationResult[`${key}`] = true;
        }
      }
      return result;
    },
  },
  computed: {
    webElememtHide() {
      let size = parseInt(this.$store.getters.getDeviceSize);
      if (size > 585) {
        return false;
      } else {
        return true;
      }
    },
    specialMemberState() {
      return this.$store.getters.getSpecialMemberState;
    },
    specialMemberData() {
      return this.$store.getters.getSpecialMemberData;
    },
    displayCityList() {
      let cityList = [];
      for (let city in this.taiwanZipcodeData) {
        cityList.push(city);
      }
      return cityList;
    },
    displayZipCodeList() {
      if (this.specialMemberData.company_address_county !== "縣市") {
        let zipcodeList = [];
        this.taiwanZipcodeData[
          `${this.specialMemberData.company_address_county}`
        ].forEach((item) => {
          let keyValue = Object.entries(item)[0];
          zipcodeList.push({
            region: keyValue[0],
            zopcode: keyValue[1],
          });
        });
        return zipcodeList;
      } else {
        return [];
      }
    },
    displayZipCodeInfo() {
      let displayZipCode = "";
      if (this.$store.getters.getZipcode === "") {
        return "郵遞區號";
      } else {
        for (let cityValue in this.taiwanZipcodeData) {
          this.taiwanZipcodeData[`${cityValue}`].forEach((region) => {
            for (let regionName in region) {
              if (region[`${regionName}`] === this.$store.getters.getZipcode) {
                displayZipCode = regionName + region[`${regionName}`];
              }
            }
          });
        }
        return displayZipCode;
      }
    },
  },
};
</script>

<style scoped lang="scss">
* {
  text-align: left;
  font-size: 17px;
  box-sizing: border-box;
}
h2 {
  color: $primaryDeepColor;
  font-size: 35px;
  margin: 0;
  @include betweenPhoneTable {
    padding-top: 20px;
  }
}
.form-container {
  max-width: 50.5%;
  color: $secondaryDeepColor1;
  @include betweenPhoneTable {
    max-width: 100%;
  }
  textarea {
    border: 1px solid $primaryDeepColor;
    padding: 10px;
  }
  .agree {
    display: flex;
    align-items: center;
    input {
      width: 20px;
    }
  }
  .wait-contract {
    h2 {
      color: $primaryDeepColor;
    }
  }
  .error-message {
    color: #f34646;
  }
}
.name-container {
  .flex-item {
    width: 48%;
    @include table {
      width: 100%;
    }
  }
}
.flex-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.address-container {
  .flex-item {
    width: 32%;
    @include table {
      width: 100%;
    }
  }
  .flex-container {
    margin-bottom: 15px;
    @include table {
      margin-bottom: 0;
    }
  }
  .flex-container > * {
    @include table {
      margin-bottom: 15px;
    }
  }
}
.form-title {
  margin-top: 15px;
  margin-bottom: 8px;
}
.statement {
  margin-bottom: 10px;
  li {
    margin-bottom: 3px;
  }
}
input {
  width: 100%;
  padding: 16px;
  font-size: 17px;
  border: 1px solid $primaryDeepColor;
  background-color: rgba(0, 0, 0, 0);
}
button {
  @extend %button;
  text-align: center;
  margin: 0; //消除預設 margin padding
  margin-top: 30px;
  @include phone {
    width: 100%;
  }
}
a {
  display: block;
  color: $primaryDeepColor;
}
.mobile_backNav {
  margin-top: 24px;
  font-weight: 600;
  display: flex;
  align-items: center;
  i {
    color: $primaryDeepColor;
    margin-right: 10px;
  }
  a {
    text-align: center;
  }
}

//dropdown
.dropdown-title {
  position: relative;
  a,
  .item {
    color: $secondaryDeepColor1;
    text-decoration: none;
    display: flex;
    align-items: center;
    border: 1px $primaryDeepColor solid;
    padding: 15px 15px 15px 10px;
    width: 100%;
  }
  a {
    background-color: rgba(0, 0, 0, 0);
  }
  .item {
    background-color: #fefff9;
  }
  .item:hover {
    color: $secondaryColor3;
    background-color: $primaryLightColor;
  }
  .title-color {
    color: $secondaryLightColor1;
  }
}
ul {
  display: block;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.choice {
  position: absolute;
  width: 100%;
  z-index: 99;
  max-height: 365px;
  overflow-y: scroll;
}
.fa {
  margin-left: auto;
  color: $primaryLightColor;
}
//loading
.load {
  padding-top: 120px;
  text-align: center;
}
.load .line:nth-last-child(1) {
  animation: loadingC 0.6s 0.1s linear infinite;
}
.load .line:nth-last-child(2) {
  animation: loadingC 0.6s 0.2s linear infinite;
}
.load .line:nth-last-child(3) {
  animation: loadingC 0.6s 0.3s linear infinite;
}
.line {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin: 3px;
  border-radius: 15px;
  background-color: #a8894c;
}
@keyframes loadingC {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 15px);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>
